import { MyPage } from '../MyPage';
import { BoughtSingleSaleOffers } from './BoughtSingleSaleOffers';
import { useSortByDate } from '../common/useSortByDate';
import { useSportSelect } from '../common/useSportSelect';

export const MyPurchases = () => {
  const { sortType, SortSelect } = useSortByDate();
  const { sportInputValue, SportSelect } = useSportSelect();

  return (
    <MyPage
      toolbar={
        <>
          <SportSelect />
          <SortSelect />
        </>
      }
    >
      <BoughtSingleSaleOffers sortType={sortType} sport={sportInputValue} />
    </MyPage>
  );
};
